import { getAddress } from './get_address';

export default function initAddressAutocomplete(container: HTMLElement, postcode_el: string, number_el: string, street_el: string, town_el: string) {
    const postcode = container.querySelector(postcode_el) as HTMLInputElement;
    if (!postcode) {
        return;
    }
    const number = container.querySelector(number_el) as HTMLInputElement;
    const street = container.querySelector(street_el) as HTMLInputElement;
    const town = container.querySelector(town_el) as HTMLInputElement;

    const handleGetAddress = async () => {
        const res = await getAddress(postcode.value, number.value);
        postcode.value = res.postcode;
        street.value = res.street;
        town.value = res.town;
    }

    postcode.addEventListener('change', handleGetAddress);
    number.addEventListener('change', handleGetAddress);
}